import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, fmtDate, formatApiError } from "@/lib/api";
import { PageHeader, Table } from "./AdminLayout";

const FILTERS = ["all", "sent", "failed"];

export default function EmailLog() {
  const [items, setItems] = useState<any[]>([]);
  const [filter, setFilter] = useState("all");
  const [busy, setBusy] = useState("");
  const load = () => api.get("/admin/emails", { params: filter === "all" ? {} : { status: filter } }).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [filter]); // eslint-disable-line
  const resend = async (id: string) => {
    setBusy(id);
    try { await api.post(`/admin/emails/${id}/resend`); toast.success("Email resent"); load(); }
    catch (err) { toast.error(formatApiError(err)); } finally { setBusy(""); }
  };
  const failed = items.filter((e) => e.status === "failed").length;
  return (
    <div data-testid="admin-emails">
      <PageHeader eyebrow="Channel" title="Email log" desc={`Every email sent from hello@bhasglobalcarenetwork.com — receipts, invoices, summaries, invites. ${failed ? `${failed} failed in this view.` : ""}`} />
      <div className="mb-5 flex flex-wrap gap-2">
        {FILTERS.map((f) => <button key={f} onClick={() => setFilter(f)} className={`rounded-full px-4 py-1.5 text-xs font-semibold capitalize transition ${filter === f ? "bg-brand-navy text-white" : "bg-white text-brand-slate ring-1 ring-brand-line"}`} data-testid={`email-filter-${f}`}>{f}</button>)}
      </div>
      <Table head={["When", "To", "Subject", "Type", "Status", ""]} testId="emails-table">
        {items.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-brand-slate" data-testid="emails-empty">No emails logged yet.</td></tr>}
        {items.map((e) => (
          <tr key={e.email_id} className="border-t border-brand-line align-top" data-testid="email-row">
            <td className="px-4 py-3 text-xs text-brand-slate">{fmtDate(e.created_at)}</td>
            <td className="px-4 py-3 text-xs font-medium text-brand-navy" data-testid="email-to">{e.to}</td>
            <td className="max-w-sm px-4 py-3 text-sm text-brand-navy">{e.subject}{e.resend_of && <span className="block text-[10px] text-brand-slate">resend of {e.resend_of}</span>}</td>
            <td className="px-4 py-3 text-xs text-brand-slate">{(e.template || "").replace(/_/g, " ")}</td>
            <td className="px-4 py-3">
              <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${e.status === "sent" ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-700"}`} data-testid="email-status">{e.status}</span>
              {e.error && <p className="mt-1 max-w-[200px] truncate text-[10px] text-red-600" title={e.error}>{e.error}</p>}
              {e.resent_at && <p className="mt-1 text-[10px] text-brand-slate">resent {fmtDate(e.resent_at)}</p>}
            </td>
            <td className="px-4 py-3 text-right">
              <button disabled={busy === e.email_id} onClick={() => resend(e.email_id)} className={`inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-xs font-semibold disabled:opacity-50 ${e.status === "failed" ? "bg-brand-blue text-white hover:bg-brand-blueHover" : "text-brand-slate ring-1 ring-brand-line hover:text-brand-navy"}`} data-testid="resend-email-button"><RefreshCw className={`h-3 w-3 ${busy === e.email_id ? "animate-spin" : ""}`} />Resend</button>
            </td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
